import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import OfficeDepartmentTable from "./view/OfficeDepartmentTable";

export const OfficeDepartment = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officedepartment_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {" "}
      {userPermissions.includes(viewPermission) && (
        <OfficeDepartmentTable />
      )}{" "}
    </>
  );
};

export default OfficeDepartment;
